import React from 'react';
import {
  BookOpenIcon,
  DocumentIcon,
  WrenchScrewdriverIcon,
  BookmarkIcon
} from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import PlaybookCard from '../../../components/playbooks/PlaybookCard';
import ResourceList from '../../../components/playbooks/ResourceList';

const guides = [
  {
    title: "Marc Barros' guide to startup off-sites",
    description: "Comprehensive guide for planning successful startup offsites",
    url: "https://marcbarros.com/startup-off-sites/"
  },
  {
    title: "First Round's offsite guide",
    description: "Detailed playbook for running impactful virtual offsites",
    url: "https://review.firstround.com/use-this-startups-playbook-for-running-impactful-virtual-offsites"
  },
  {
    title: "Founder's Club Offsite Guide",
    description: "Practical advice for planning and executing productive team offsites",
    url: "https://fundersclub.com/blog/2017/04/27/guide-to-offsites/"
  },
  {
    title: "Introvert friendly off-sites",
    description: "Tips for designing off-site activities that work well for introverted team members",
    url: "https://medium.com/the-love-lock/team-offsite-events-that-even-an-introver-can-love-a763754229d4"
  },
  {
    title: "Zapier's offsite guide",
    description: "Practical guide for running company retreats with remote teams",
    url: "https://zapier.com/blog/how-run-company-retreat-remote-team/"
  }
];

const tools = [
  {
    title: "Liberating Structures' Facilitation Tools",
    description: "A collection of 33 facilitation methods to release the potential of your team through inclusive participation",
    url: "https://www.liberatingstructures.com/"
  },
  {
    title: "Team charter Miro template",
    description: "Ready-to-use Miro board template for creating a team charter during your offsite",
    url: "https://miro.com/guides/team-charter/"
  },
  {
    title: "Design a Better Business's Team charter canvas",
    description: "Structured canvas template for developing a team charter with clear roles and guidelines",
    url: "https://www.designabetterbusiness.tools/tools/team-charter-canvas"
  }
];

const CultureOffsiteUsefulResources = () => (
  <div className="max-w-none text-gray-300">
    <PlaybookSection
      title="Useful Resources"
      icon={<BookOpenIcon className="h-7 w-7 text-primary-light" />}
      heading="h1"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <PlaybookCard>
          <ResourceList 
            title="Guides & Articles" 
            items={guides} 
            icon={DocumentIcon}
          />
        </PlaybookCard>
        <PlaybookCard>
          <ResourceList 
            title="Tools & Templates" 
            items={tools} 
            icon={WrenchScrewdriverIcon}
          />
        </PlaybookCard>
      </div>
    </PlaybookSection>
  </div>
);

export default CultureOffsiteUsefulResources; 